/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosports1ColumnBannerViewProps } from '../../../modules/hosports-1-column-banner/./hosports-1-column-banner';
import Banner from '../../../baseComponents/banner/./banner';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';

export default (props: IHosports1ColumnBannerViewProps) => {
  let config = props.config;
  let link = '';
  let linkText = '';
  if(config.link){
    if(config.link.linkText){
      linkText = config.link.linkText
    }
    if(config.link.linkUrl){
      link = config.link.linkUrl.destinationUrl;
    }
  }
  return (
      <ScrollFadeIn>
        <div className="site-gutter">
          <Banner
            title={config.title}
            subTitle={config.subTitle}
            image={config.image ? config.image.src : undefined}
            mobileImage={config.mobileImage ? config.mobileImage.src : undefined}
            verticalPosition={config.verticalPosition}
            horizontalPosition={config.horizontalPosition}
            link={link}
            buttonText={linkText}
            tint={config.tint}
            height={config.height}
            />
        </div>
      </ScrollFadeIn>
  );
};
